import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Config } from './config';

import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {
    CompositeLocComponent,
    CompositeLocComponentInput,
} from '../components/map/composite-loc/composite-loc.component';
import { LocationDetails } from '../models/location-details';
import { LocationCardContainerDialogComponent } from '../components/location-card/components/location-card-container/location-card-container.component';
import { IComponentModalResult } from '../models/modal';

@Injectable()
export class MapService {
    public addEditLocationDialog: MatDialogRef<LocationCardContainerDialogComponent, boolean>;
    public addEditCompositeDialog: MatDialogRef<CompositeLocComponent, IComponentModalResult>;

    constructor(public http: HttpClient, public dialog: MatDialog) {}

    public getMarkerLocationDetails(locationId: number, customerId: number) {
        return this.http.get<LocationDetails>(Config.urls.markerLocationDetails + customerId + '/' + locationId);
    }

    public closeDialog(result?: boolean) {
        if (this.addEditLocationDialog) this.addEditLocationDialog.close(result);
        if (this.addEditCompositeDialog) this.addEditCompositeDialog.close();
    }

    public openEditCompositeDialog(dialogOptions: MatDialogConfig<CompositeLocComponentInput>, close = false) {
        if (close) this.closeDialog();

        this.addEditCompositeDialog = this.dialog.open<
            CompositeLocComponent,
            CompositeLocComponentInput,
            IComponentModalResult
        >(CompositeLocComponent, dialogOptions);

        return this.addEditCompositeDialog.afterClosed();
    }

}
